import { Compass } from "lucide-react";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";
import { StatusCard } from "@/features/auth/components/status-card";
import { VerificationShell } from "@/features/auth/components/verification-shell";

export function NotFoundPage() {
	return (
		<VerificationShell>
			<StatusCard
				tone="muted"
				icon={<Compass />}
				title="Página não encontrada"
				description="O endereço que você abriu não existe ou foi movido."
				action={
					<Button asChild className="status-card__action">
						<Link to="/">Voltar para o início</Link>
					</Button>
				}
			/>
		</VerificationShell>
	);
}
